import {
  resetSelectionIfNotInBatch,
  toggleGroupSelection,
  toggleRowSelection,
} from './multiselect';
import React, { Context, useContext } from 'react';
import Row from './Row';
import { ListState } from '..';
import styles from '../VirtualizedList.module.scss';

export default ({ index, style, data }) => {
  const {
    highlightedIdx,
    highlightEvtType,
    selectedItems,
    lastToggledCheckboxIdx,
    contextMenuTarget,
    contextMenuDisabled,
    listActive,
    indicateRowLoadingState,
  } = useContext(data.ListContext as Context<ListState>);
  const item = data.items[index];
  const toggleHandlerCtx = {
    selectedItems,
    lastToggledCheckboxIdx,
    setSelectedItems: data.setSelectedItems,
    setLastToggledCheckboxIdx: data.setLastToggledCheckboxIdx,
    setHighlightedIdx: data.setHighlightedIdx,
  };

  const toggleRowOrGroup = (e) => {
    e.stopPropagation();

    if (data.disabled) {
      return;
    }

    if (e.shiftKey) {
      toggleGroupSelection(toggleHandlerCtx, data.items, item, index);
    } else {
      toggleRowSelection(toggleHandlerCtx, item, index);
    }
  };

  const handleRowClick = (e) => {
    if (!item.isFetching && !data.disabled) {
      if (e.shiftKey && lastToggledCheckboxIdx != -1) {
        toggleGroupSelection(toggleHandlerCtx, data.items, item, index);
      } else if (data.isMultiselect && !data.onItemClick) {
        toggleRowSelection(toggleHandlerCtx, item, index);
      } else {
        data.onItemClick?.(item, e);
      }
    }
  };

  const handleContextMenu = () => resetSelectionIfNotInBatch(toggleHandlerCtx, item, index);

  if (!item) {
    return <div key={index} style={style} />;
  }

  if (item.id == 'paddingRow') {
    return <div key="padding-row" style={style} />;
  }

  if (item.id == 'sectionHeader') {
    return (
      <div key={item.label} className={styles.sectionHeaderRow} style={style}>
        {item.label}
      </div>
    );
  }

  return (
    <Row
      key={item.id}
      id={item.id}
      style={style}
      isMultiselect={data.isMultiselect}
      isHighlighted={index == highlightedIdx}
      isSelected={selectedItems.has(item.id)}
      isUpdating={indicateRowLoadingState && item.isFetching}
      isDeleting={item.isDeleting}
      highlightRow={(shiftKeyPressed: boolean) => {
        data.setHighlightedIdx([index, 'mouse', shiftKeyPressed]);
      }}
      isActiveList={listActive}
      onClick={handleRowClick}
      onContextMenu={handleContextMenu}
      toggleRowOrGroupSelection={toggleRowOrGroup}
      isLastToggledRow={index == lastToggledCheckboxIdx}
      listRowClassName={data.listRowClassName}
      itemBasedListRowClassName={data.itemBasedListRowClassName}
      disabled={data.disabled || item.id === 'sectionHeader'}
      selectedItems={selectedItems}
      canDrag={data.canDrag}
      contextMenuTarget={contextMenuTarget || 'Contact'}
      contextMenuDisabled={contextMenuDisabled}
      scrollIntoView={() =>
        // If user is close to the top of the list (index < 6), just scroll to the top
        highlightEvtType === 'keyboard' && data.scrollToIndex(index < 6 ? 0 : index)
      }
    >
      {data.renderItem(item, index == highlightedIdx, selectedItems.size > 1, index)}
    </Row>
  );
};
